<!-- Session Switching Loader -->
<div class="session-switching-overlay" *ngIf="isSessionSwitching">
  <div class="session-switching-loader">
    <div class="spinner"></div>
    <p class="loading-text">Switching Session...</p>
    <p class="loading-subtext">Please wait while we load your session</p>
  </div>
</div>

<app-demo-banner></app-demo-banner>
<simple-notifications  [options]="notifierOptions"></simple-notifications>
<app-permission-denied-popup></app-permission-denied-popup>
<router-outlet></router-outlet>